<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="12" md="2" class="py-2">
              <span>
                <b>Report Details</b>
              </span>
            </b-col>
            <b-col cols="12" md="8" class="py-2"></b-col>

            <b-col cols="6" md="2" class="pt-2">
              <b-row class="justify-content-center">
                <!-- <b-col cols="12">
                    <br />
                </b-col>-->
                <b-col cols="12">
                  <!-- <b-button variant="outline-primary" class="block" to="/AddReport">
                    <b>Print Report</b>
                  </b-button>-->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <div v-if="report">
          <b-row>
            <b-col>
              <span>
                <b>
                  Report Id :
                  <span style="color:#0099ff">{{report.reportID}}</span>
                </b>
              </span>
            </b-col>
          </b-row>

          <b-row v-if="report.photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img :src="baseURL+'/file/get/'+report.photo" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row v-if="report.photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img src="../../assets/igfooter.png" width="20%" height="100%" />
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="4">
              <b-form-group label="Type of crime">
                <b-form-input
                  v-model="report.crimeTypeId.cname"
                  type="text"
                  id="crimetype"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pt-3">
            <b-col cols="12" md="4">
              <b-form-group label="Suspect Last Name">
                <b-form-input v-model="report.suspectLastName" type="text" id="lastname" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Suspect First Name">
                <b-form-input v-model="report.suspectFirstName" type="text" id="firstname" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Suspect Middle Name">
                <b-form-input
                  v-model="report.suspectMiddleName"
                  type="text"
                  id="middlename"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Country">
                <b-form-input v-model="report.country" type="text" id="country" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Nationality">
                <b-form-input v-model="report.nationality" type="text" id="nationality" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Date">
                <b-form-input v-model="rdate" type="text" id="date" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group label="Last Known Address">
                <b-form-textarea
                  id="lastknown"
                  v-model="report.knownAddress"
                  rows="3"
                  disabled
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <b-form-group label="Crime Synopsis ">
                <b-form-textarea
                  id="crime"
                  v-model="report.crimeSynopsis"
                  rows="3"
                  disabled
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Business Name">
                <b-form-input v-model="report.businessName" type="text" id="businessName" disabled></b-form-input>
              </b-form-group>
            </b-col> 
            <b-col cols="12" md="4">
              
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Contributing Name ">
                <b-form-input disabled v-model="report.contributingName" id="cname"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Contributing Email ">
                <b-form-input disabled v-model="report.contributingEmail" id="cemail"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Contributing Phone ">
                <b-form-input disabled v-model="report.contributingPhone" id="cphone"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Contributing Agency ">
                <b-form-input disabled v-model="report.contributingAgency" id="cagency"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />

          <b-card no-header>
            <template slot="header">Other Attachments</template>

            <b-table
              :hover="true"
              :striped="false"
              :bordered="false"
              :small="false"
              :fixed="false"
              responsive="sm"
              :items="Attachments"
              :fields="receiptfields"
            >
              <template v-slot:cell(type)="data">
                <span v-if="data.item.attachType == 'casereport'">Case Report</span>
                <span v-if="data.item.attachType == 'photos'">Photos</span>
                <span v-else-if="data.item.attachType == 'fingerprints'">Finger Prints</span>
                <span v-else-if="data.item.attachType == 'others'">Others</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(files)="data">
                <span v-if="data.item">
                  <a
                    v-if="data.item.attachType == 'photo'|| data.item.attachType == 'fingerprints'"
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  >
                    <img
                      v-bind:src="baseURL+'/file/get/'+data.item.name"
                      width="auto"
                      height="100px"
                    />
                  </a>
                  <a
                    v-else-if="data.item.attachType == 'casereport' && filexetn(data.item.name) === false"
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  >View Report</a>
                  <a
                    v-else-if="data.item.attachType == 'others' && filexetn(data.item.name) === false"
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  >View Attachment</a>
                   <a
                    v-else
                    target="_blank"
                    :href="baseURL+'/file/get/'+data.item.name"
                  > <img
                      v-bind:src="baseURL+'/file/get/'+data.item.name"
                      width="auto"
                      height="100px"
                    /></a>
                  
                  
                </span>
                <span v-else>-</span>
              </template>
            </b-table>
          </b-card>

          <b-row
            v-if="userRole=='admin' && (userType== 0 || userType== 1)"
            class="justify-content-center"
          >
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                :to="'/EditReport/'+$route.params.id"
              >Edit Report</b-button>
            </div>
            <!-- <div class="px-2">
              <b-button
                variant="success"
                size="sm"
                v-if="report.isreviewed"
                @click.prevent="confirmVerifyReport('not verified.')"
              >Mark as Not Verified</b-button>
              <b-button
                variant="success"
                size="sm"
                v-else
                @click.prevent="confirmVerifyReport('verified.')"
              >Mark as Verified</b-button>
            </div>-->
            <div class="px-2">
              <b-button
                variant="danger"
                size="sm"
                @click.prevent="confirmRemoveReport"
              >Remove Report</b-button>
            </div>
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import locationMap from "./map";
import axios from "axios";

export default {
  components: {
    locationMap,
  },
  data() {
    return {
      report: null,
      appLoading: false,
      ServerError: false,
      rdate: null,
      // userRole: localStorage.getItem("role"),
      userRole: "admin",
      Attachments: null,
      userType: localStorage.getItem("usrType"),
      userRole: localStorage.getItem("role"),
      receiptfields: [
        // { key: "accountcreateat", label: "Created on", sortable: false },

        { key: "type", label: "Type ", sortable: false },
        // { key: "type", label: "Type ", sortable: false },
        { key: "files", label: "File", sortable: false },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/report/view/" + this.$route.params.id,
        // params: {
        //   id: this.$route.params.id,thi
        // },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.report = response.data.data;
          this.Attachments = response.data.data.attachments;
          this.rdate = this.formatDate(this.report.added_date);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmRemoveReport() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to Remove this Report. All data will be lost for this Report",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.removeReport();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    confirmVerifyReport(item) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to mark this report as " + item,
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.verifyReport(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    removeReport() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/report/delete/" + this.$route.params.id,
        // data: {
        //   id: this.$route.params.id,
        // },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    verifyReport(item) {
      this.appLoading = true;
      var status = false;
      if (item == "verified.") status = true;
      axios({
        method: "POST",
        url: "/report/reviewstatus",
        data: {
          status: status,
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getData();
          // this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },

    filexetn(extfile){
       var file= extfile;
       var reg = /(.*?)\.(jpg|bmp|jpeg|png)$/;
       if(!file.match(reg))
       {
    	   
    	   return false;
       }
       },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
  },
};
</script>
<style scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #e4e7ea;
  opacity: 1;
  color: black;
}
</style>